import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

const OPT_OUT_CACHE_EXPIRATION_SECONDS = 365 * 24 * 60 * 60; // 1 year

export const updateNav4AdminOptInCache = (nav4AdminOptIn: boolean) => {
	if (nav4AdminOptIn) {
		localStorage.setItem(keys.NAV4_ADMIN_OPT_IN_CACHE, true, OPT_OUT_CACHE_EXPIRATION_SECONDS);
	} else {
		// the value is null and has never been set
		localStorage?.removeItem(keys.NAV4_ADMIN_OPT_IN_CACHE);
	}
};

export const getNav4AdminOptInCache = () => {
	return localStorage?.getItem(keys.NAV4_ADMIN_OPT_IN_CACHE) === 'true';
};
